module.exports = __webpack_public_path__ + "static/media/uop_logo.aa86f163.svg";